import { Point3d, Range3d } from "@itwin/core-geometry";

import { IssueData } from "./Issues";
import { cDatabaseApi, cDbQuery } from "./DatabaseApi";

export class cIssuesApi {

  public static getProjectIssues = async (projectId: string, issuesList: Map<number, IssueData>) => {
    const q = new cDbQuery("Issues");
    const dbRows = await cDatabaseApi.query(q);
    while (dbRows.next()) {
      const dbIssue = this.retrieveIssue(dbRows.getCurrent());
      if (dbIssue) {
        // if (dbIssue.id > cIssue._issueId) cIssue._issueId = dbIssue.id;  //!!OA
        issuesList.set(dbIssue.id, dbIssue);
      }
    }
  }

  public static addIssue = async (issue: IssueData): Promise<boolean> => {
    const q = new cDbQuery("Issues");
    q.setData(issue);
    const status = await cDatabaseApi.add(q);

    return status;
  }

  public static updateIssue = async (issue: IssueData): Promise<boolean> => {
    const q = new cDbQuery("Issues");
    q.setWhere("id", issue.id);
    q.setData(issue);
    const status = await cDatabaseApi.update(q);

    return status;
  }

  public static deleteIssue = async (issue: IssueData): Promise<boolean> => {
    const q = new cDbQuery("Issues");
    q.setWhere("id", issue.id);
    const status = await cDatabaseApi.delete(q);

    return status;
  }

  private static retrieveIssue = (dbIssue: any): IssueData | undefined => {
    if (dbIssue) {
      const issue = new IssueData();
      issue.id = Number(dbIssue.id);
      issue.type = dbIssue.type;
      issue.priority = dbIssue.priority;
      issue.title = dbIssue.title;
      issue.description = dbIssue.description;
      issue.assignedTo = dbIssue.assignedTo;
      issue.status = dbIssue.status;
      issue.createdBy = dbIssue.createdBy;
      issue.lastModifiedBy = dbIssue.lastModifiedBy;

      issue.location.setFrom(dbIssue.location);
      if (dbIssue.eyePoint && dbIssue.targetPoint) {
        issue.eyePoint.setFrom(dbIssue.eyePoint);
        issue.targetPoint.setFrom(dbIssue.targetPoint);
      }

      if (dbIssue.clipRange) {
        issue.clipRange = Range3d.create(
          dbIssue.clipRange.high,
          dbIssue.clipRange.low
        );
      }

      return issue;
    }

    return undefined;
  }

  public static getIssueCount = async (): Promise<number> => {
    var count: string;
    const q = new cDbQuery("IssueCount");
    q.setWhere("key", "issueCounter");
    const dbRows = await cDatabaseApi.query(q);
    if (dbRows.next()) {
      count = dbRows.getProperty("issueCount");
      return Number(count);
    }

    return 0;
  }

  public static setIssueCount = async (count: number): Promise<boolean> => {
    const q = new cDbQuery("IssueCount");
    const issueCount = {
      issueCount: count.toString(),
    };

    q.setWhere("key", "issueCounter");
    q.setData(issueCount);
    const status = await cDatabaseApi.update(q);

    return status;
  }
}
